import { ProductLineId } from '@insurancemenu/imenu-components-lib/dist/types/ProductLineId';
import { makeAutoObservable } from 'mobx';
import { RootStore } from 'store/rootStore';

export class HelpMeDecideStore {
  rootStore: RootStore;
  loading = false;
  criteriaIndex = 1;
  currentProductLine: ProductLineId = 'GroupDental';

  public setLoading(loadingStatus: boolean): void {
    this.loading = loadingStatus;
  }

  public setCurrentProductLine(currentProductLine: ProductLineId): void {
    this.currentProductLine = currentProductLine;
  }

  public setCriteriaIndex(index: number): void {
    this.criteriaIndex = index;
  }

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;

    makeAutoObservable(this, {}, { autoBind: true });
  }
}
